import { Accordion, Badge, Card, Col, OverlayTrigger, Row, Table, Tooltip } from "react-bootstrap";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { DEV_SERVER } from "../../../constants/urls";
import { toast } from "react-toastify";
import { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import { userSignal } from "../../../signal/userSignal";

import * as moment from "moment";
import Zoom from 'react-medium-image-zoom'
import 'react-medium-image-zoom/dist/styles.css'
import DataTable from "react-data-table-component";
import avatar1 from "../../../assets/images/avatars/01.png"
import { allUsersSignal } from "../../../signal/allUsersSignal";
import AddDealerModal from "./AddDealerModal";
import { confirmAlert } from 'react-confirm-alert'; // Import
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useSearchParams } from "react-router-dom";
import { dealerSignal } from "../../../signal/dealerSignal";
import Select from "react-select";
import { dealerVisitsExcelGenerator } from "../../../utilities/excelGenerator";

export default function DealersVisits() {

    let today = Date.now();
    // get date start Time of 7 days ago in milliseconds
    let sevenDaysAgo = new Date(today - 7 * 24 * 60 * 60 * 1000).getTime();

    const [searchParams, setSearchParams] = useSearchParams();
    const [visits, setVisits] = useState([]);
    const [visitsToDisplay, setVisitsToDisplay] = useState([]);
    const [fromDate, setFromDate] = useState(searchParams.get("fromDate") ? searchParams.get("fromDate") : moment(sevenDaysAgo).format("YYYY-MM-DD"));
    const [toDate, setToDate] = useState(searchParams.get("toDate") ? searchParams.get("toDate") : moment(today).format("YYYY-MM-DD"));
    const [dealerId, setDealerId] = useState(searchParams.get("dealerId") ? searchParams.get("dealerId") : "");
    const [userId, setUserId] = useState(searchParams.get("userId") ? searchParams.get("userId") : "");
    const [city, setCity] = useState(searchParams.get("city") ? searchParams.get("city") : "");
    const [state, setState] = useState(searchParams.get("state") ? searchParams.get("state") : "");
    const [search, setSearch] = useState("");
    const [page, setPage] = useState(1);
    const [perPage, setPerPage] = useState(10);
    const [totalItems, setTotalItems] = useState(0);

    // useEffect(() => {
    //     setVisitsToDisplay(visits.filter((item) => {
    //         if (search === "") return true;
    //         if (item?.name?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.gstin?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.phoneNumber?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.address?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.city?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.state?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.pincode?.toString().toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.email?.toLowerCase().includes(search.toLowerCase())) return true;
    //         if (item?.website?.toLowerCase().includes(search.toLowerCase())) return true;
    //         let user = allUsersSignal.value[item.userId];
    //         if (user) {
    //             if (user.name.toLowerCase().includes(search.toLowerCase())) return true;
    //         }
    //         if (moment(item.createdAt).format("DD/MM/YY hh:mm A").toLowerCase().includes(search.toLowerCase())) return true;

    //         return false;
    //     }))
    // }, [search, visits])

    const handleDisplayFields = () => {
        setVisitsToDisplay(visits.filter((item) => {
            if (search === "") return true;
            if (moment(item?.createdAt).format("DD/MM/YY").toLowerCase().includes(search.toLowerCase())) return true;
            if (allUsersSignal?.value[item.userId] && allUsersSignal?.value[item.userId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (dealerSignal?.value[item.dealerId] && dealerSignal?.value[item.dealerId]?.name.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.title?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.description?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.status?.toLowerCase().includes(search.toLowerCase())) return true;
            if (item?.remarks?.toLowerCase().includes(search.toLowerCase())) return true;
            return false;
        }))
    }

    const getVisits = useQuery("dealerVisits", async ({ signal }) => {
        let resp = await axios.get(`${DEV_SERVER}/trip/v2/task/getDealerVisits?page=${page}&perPage=${perPage}&startTime=${new Date(fromDate).setHours(0, 0, 0, 0)}&endTime=${new Date(toDate).setHours(23, 59, 59, 999)}&dealerId=${dealerId}&userId=${userId}&city=${city}&state=${state}`, {
            headers: {
                Authorization: `Bearer ${userSignal.value?.token}`,
            },
            signal: signal
        });
        return resp.data;
    }, {
        enabled: false,
        onSuccess: (data) => {
            if (data.status) {
                setVisits(data.data?.data || []);
                setPage(data.data?.page || 1);
                setPerPage(data.data?.perPage || 10);
                setTotalItems(data.data?.totalItems || 0);
            } else {
                toast.error(data.message);
            }
        },

        onError: (error) => {
            if (error.response?.data?.message) {
                toast.error(error.response.data.message);
            } else {
                toast.error("Something went wrong");
            }
        }
    });

    const refetchVisits = () => {
        getVisits.refetch({ cancelRefetch: true });
    }

    const handleFilters = async () => {

        const tempSearchParam = new URLSearchParams({ fromDate: fromDate, toDate: toDate, city: city, state: state, dealerId: dealerId, userId: userId })
        setSearchParams(tempSearchParam);
        setPage(1);

        await refetchVisits();
        handleDisplayFields();
    }

    useEffect(() => {
        handleDisplayFields();
    }, [search, visits])

    useEffect(() => {
        refetchVisits();
    }, [page, perPage])

    const columns = [
        {
            name: "Title",
            selector: "title",
            cell: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.title}</Tooltip>}>
                    <span>{row?.title}</span>
                </OverlayTrigger>
            },
            center: true,
        },
        {
            name: "Description",
            selector: "description",
            center: true,
            cell: (row) => {
                return row?.description === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.description}</Tooltip>}>
                    <span>{row?.description}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Status",
            selector: (row) => {
                return row?.status === "pending" ? <Badge bg="warning">{row?.status}</Badge> : <Badge bg="success">{row?.status}</Badge>
            },
            center: true,
            width: "100px"
        },
        {
            name: "Dealer",
            selector: "dealerId",
            cell: (row) => {
                if (dealerSignal?.value && dealerSignal?.value[row?.dealerId]) {
                    return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{dealerSignal.value[row?.dealerId]?.name}</Tooltip>}>
                        <span>{dealerSignal.value[row?.dealerId]?.name}</span>
                    </OverlayTrigger>
                }
                return "-"
            },
            center: true,
            width: "200px"
        },
        {
            name: "Remarks",
            selector: "remarks",
            center: true,
            cell: (row) => {
                return row?.remarks === "" ? "NA" : <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{row?.remarks}</Tooltip>}>
                    <span>{row?.remarks}</span>
                </OverlayTrigger>
            }
        },
        {
            name: "Remark image",
            center: true,
            selector: (row) => <div style={{ display: "flex", columnGap: "0.5rem", flexWrap: "wrap" }}>
                {row?.media?.length > 0 && row?.media?.map((m) =>
                    <Zoom key={m._id}><img src={m.url} onLoad={(e) => { e.target.style.pointerEvents = "unset" }} onError={(e) => { e.target.style.pointerEvents = "none" }} style={{ pointerEvents: "none", cursor: "pointer", width: "25px", height: "25px", borderRadius: "10px" }} /></Zoom>

                )}
            </div>
        },
        {
            name: "Address",
            selector: (row) => {
                return <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>{`${row?.destinationArea !== "" ? row?.destinationArea + ", " : ""}${row?.destinationCity !== "" ? row?.destinationCity + ", " : ""}${row?.destinationState !== "" ? row?.destinationState + ", " : ""}`}</Tooltip>}>
                    <span>{`${row?.destinationArea !== "" ? row?.destinationArea + ", " : ""}${row?.destinationCity !== "" ? row?.destinationCity + ", " : ""}${row?.destinationState !== "" ? row?.destinationState + ", " : ""}`}</span>
                </OverlayTrigger>
            },
            width: "300px",
            center: true,
        },
        {
            name: "User",
            selector: (row) => {
                if (row?.userId?.length) {
                    return (
                        <div style={{ columnGap: "0.4rem" }}>
                            <OverlayTrigger placement="top" overlay={
                                <Tooltip style={{ position: "fixed" }} id="tooltip-top">
                                    {allUsersSignal.value[row?.userId]?.name}
                                </Tooltip>}>
                                <span style={{ width: "100%" }}>{allUsersSignal.value[row?.userId]?.name}</span>
                            </OverlayTrigger>
                        </div>
                    )
                }
                return "-"
            },
            center: true,
            width: "150px"
        },
        {
            name: "Completed Location",
            width: "100px",
            selector: (row) => {

                return <span className="d-flex justify-content-between align-items-start" style={{ columnGap: "0.5rem" }}>
                    {(row?.completedAt === "" || row?.completedAt === null || row?.completedAt === undefined || row?.completedAt === 0) ? "-" :
                        <span className="d-flex flex-column">
                            <p className="mb-1">{moment(row?.completedAt).format("DD/MM/YY")}</p>
                            <p className="mb-0" style={{ color: "rgba(0, 0, 0, 0.625)", fontSize: "10px" }}>{moment(row?.completedAt).format("hh:mm A")}</p>
                        </span>
                    }

                    {row?.completedAtLocation?.length > 0 && <OverlayTrigger placement="top" overlay={<Tooltip style={{ position: "fixed" }}>View on Map</Tooltip>}><a href={`https://www.google.com/maps/search/?api=1&query=${row?.completedAtLocation[0]},${row?.completedAtLocation[1]}`} target="_blank" ><i class="fas fa-map-marker-alt"></i></a></OverlayTrigger>}

                </span>
            },
            center: true,
        }
    ]

    return (
        <>
            <div>
                <Row>
                    <Col sm="12">
                        <Card>
                            <Card.Header className="d-flex justify-content-between">
                                <div className="header-title">
                                    <h4 className="card-title">Dealers Visits</h4>
                                </div>
                            </Card.Header>
                            <Card.Body>
                                <Accordion>
                                    <Accordion.Item eventKey="0">
                                        <Accordion.Header>Filters</Accordion.Header>
                                        <Accordion.Body>
                                            <div className="flex-wrap" style={{ display: "flex", alignItems: "center", columnGap: "1rem", rowGap: "0.7rem", marginBottom: "1rem" }}>
                                                <div>
                                                    <label htmlFor="fromDate">From Date</label>
                                                    <input type="date" id="fromDate" className="form-control vanila-datepicker" names="start" placeholder="From Date" defaultValue={fromDate} onChange={(e) => {
                                                        setFromDate(e.target.value)

                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="toDate">To Date</label>
                                                    <input type="date" id="toDate" className="form-control vanila-datepicker" names="start" placeholder="To Date" defaultValue={toDate} onChange={(e) => {
                                                        setToDate(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="city">City</label>
                                                    <input type="text" id="city" className="form-control" placeholder="Enter City" value={city} onChange={(e) => {
                                                        setCity(e.target.value)
                                                    }} />
                                                </div>
                                                <div>
                                                    <label htmlFor="state">State</label>
                                                    <input type="text" id="state" className="form-control" placeholder="Enter State" value={state} onChange={(e) => {
                                                        setState(e.target.value)
                                                    }} />
                                                </div>

                                                <div>
                                                    <label htmlFor="dealer">Dealer</label>
                                                    <Select
                                                        options={Object.keys(dealerSignal.value).map((key) => {
                                                            return { value: dealerSignal.value[key].id, label: dealerSignal.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setDealerId(e.value);
                                                            } else {
                                                                setDealerId("");
                                                            }
                                                        }}

                                                        value={dealerSignal.value[dealerId] ? { value: dealerSignal.value[dealerId].id, label: dealerSignal.value[dealerId].name } : null}

                                                        isClearable
                                                    />
                                                </div>
                                                <div>
                                                    <label htmlFor="user">User</label>
                                                    <Select
                                                        options={Object.keys(allUsersSignal?.value).map((key) => {
                                                            return { value: allUsersSignal?.value[key].id, label: allUsersSignal?.value[key].name }
                                                        })}
                                                        onChange={(e) => {
                                                            if (e && e.value) {
                                                                setUserId(e.value);
                                                            } else {
                                                                setUserId("");
                                                            }
                                                        }}

                                                        value={allUsersSignal?.value[userId] ? { value: allUsersSignal?.value[userId].id, label: allUsersSignal?.value[userId].name } : null}

                                                        isClearable
                                                    />
                                                </div>

                                            </div>
                                            <div className="d-flex justify-content-end" style={{ columnGap: '1rem' }}>
                                                <button className="btn btn-light ms-2" onClick={() => {
                                                    setFromDate(moment(sevenDaysAgo).format("YYYY-MM-DD"));
                                                    setToDate(moment(today).format("YYYY-MM-DD"));
                                                    setCity("");
                                                    setState("");
                                                    setDealerId("");
                                                    setUserId("");
                                                    const tempSearchParam = new URLSearchParams({ fromDate: moment(sevenDaysAgo).format("YYYY-MM-DD"), toDate: moment(today).format("YYYY-MM-DD"), minAmount: 0, maxAmount: 0, stageFilter: "", dealerId: "", userId: "" });
                                                    setSearchParams(tempSearchParam);
                                                }}>Reset</button>
                                                <button className="btn btn-primary" onClick={handleFilters}>Apply changes</button>
                                            </div>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </Accordion>
                                <div className="mt-4" style={{ display: "flex", alignItems: "center", columnGap: "1rem", marginBottom: "1rem", justifyContent: "space-between" }}>
                                    <div>
                                        <label htmlFor="search">Search</label>
                                        <input type="search" id="search" className="form-control vanila-datepicker" names="start" placeholder="Search anything..." value={search} onChange={(e) => setSearch(e.target.value)} />
                                    </div>

                                    <div className="d-flex col-4" style={{ columnGap: "1rem", whiteSpace: "nowrap"}}>
                                        <Card className="bg-soft-info col-8 p-0 mb-0" style={{ height: "60px" }}>
                                            <Card.Body className="py-1">
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div className="bg-soft-info rounded p-1">
                                                        <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 0 20 20" fill="currentColor">
                                                            <path fillRule="evenodd" d="M10 9a3 3 0 100-6 3 3 0 000 6zm-7 9a7 7 0 1114 0H3z" clipRule="evenodd" />
                                                        </svg>
                                                    </div>
                                                    <div className="text-end">
                                                        <h4 className="counter">{totalItems}</h4>
                                                        Total Visits
                                                    </div>
                                                </div>
                                            </Card.Body>
                                        </Card>
                                        <button className="btn btn-success"
                                            disabled={(getVisits.isFetching || getVisits.isLoading)}
                                            onClick={() => dealerVisitsExcelGenerator(visits, `${"Dealer Visits"}-${fromDate}-${toDate}`)}
                                        >
                                            <svg id="SvgjsSvg1001" width="20" height="20" xmlns="http://www.w3.org/2000/svg" version="1.1" xmlnsXlink="http://www.w3.org/1999/xlink" xmlnsSvgjs="http://svgjs.com/svgjs"><defs id="SvgjsDefs1002"></defs><g id="SvgjsG1008"><svg xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd" image-rendering="optimizeQuality" shape-rendering="geometricPrecision" text-rendering="geometricPrecision" viewBox="0 0 18765 21993" width="20" height="20"><path fill-rule="nonzero" d="M4317 0l9063 0c285,0 530,102 731,303l4351 4350c201,202 303,447 303,732l0 13155c0,910 -742,1652 -1653,1652l-11137 0c-53,0 -98,-28 -123,-75 -24,-46 -20,-99 10,-142l777 -1104c26,-38 66,-59 112,-59l10361 0c150,0 273,-123 273,-272l0 -12943 -2764 0c-801,0 -1454,-653 -1454,-1454l0 -2763 -8850 0c-150,0 -273,123 -273,272l0 10524c0,75 -62,137 -138,137l-1104 0c-76,0 -138,-62 -138,-137l0 -10524c0,-910 742,-1652 1653,-1652zm2039 17106l-1288 0c-159,0 -288,-129 -288,-288l0 -3424c0,-158 -129,-287 -288,-287l-2339 0c-159,0 -288,129 -288,287l0 3424c0,159 -129,288 -288,288l-1288 0c-110,0 -205,58 -255,155 -51,98 -44,209 20,299l3033 4311c56,79 139,122 235,122 97,0 180,-43 236,-122l3033 -4311c64,-90 71,-201 20,-299 -50,-97 -145,-155 -255,-155zm-394 -12701l3588 0c107,0 194,88 194,195l0 775c0,107 -87,194 -194,194l-3588 0c-107,0 -194,-87 -194,-194l0 -775c0,-107 87,-195 194,-195zm970 3727l0 2150 4056 0 0 -2150 -4056 0zm0 3314l0 2150 4056 0 0 -2150 -4056 0zm5220 -1164l2345 0 0 -2150 -2345 0 0 2150zm2345 1164l-2345 0 0 2150 2345 0 0 -2150zm1164 -3509l0 2539 0 775 0 2539 0 355 0 420c0,107 -87,194 -194,194l-9505 0c-107,0 -194,-87 -194,-194l0 -420 0 -355 0 -2539 0 -775 0 -2539 0 -355 0 -420c0,-107 87,-194 194,-194l9505 0c107,0 194,87 194,194l0 420 0 355z" fill="white" class="color000 svgShape"></path></svg></g></svg> Export
                                        </button>
                                    </div>
                                </div>
                                {(!getVisits.isLoading && !getVisits?.isFetching) &&
                                    <DataTable
                                        customStyles={{ cells: "center" }} columns={columns} data={visitsToDisplay} pagination={true}
                                        paginationServer={true} paginationTotalRows={totalItems} paginationPerPage={perPage} paginationRowsPerPageOptions={[10, 20, 30, 40, 50]}
                                        paginationDefaultPage={page}
                                        onChangeRowsPerPage={(currentRowsPerPage, currentPage) => {
                                            setPerPage(currentRowsPerPage);
                                        }
                                        } onChangePage={(currentPage) => {
                                            setPage(currentPage);
                                        }}
                                    />}
                                {(getVisits.isLoading || getVisits?.isFetching) && <div className="d-flex justify-content-center">
                                    <div className="spinner-border" role="status">
                                        <span className="visually-hidden">Loading...</span>
                                    </div>
                                </div>}
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>
            </div>
        </>
    )
}